export enum Paths {
  challenges = "/challenges",
  challengeDetails = "/challenges/:id",
  editChallengeDetails = "/challenges/:id/edit",
  submitSolution = "/challenges/:id/submit-solution/:solutionId",
  mySolutions = "/mysolutions",
  solutions = "/solutions",
  feekbacks = "/solutions/feedbacks",
  solutionsFeedback = "/solutions/feedback",
  solutionDetails = "/solutions/:id",
  solutionDetailsFeedbacks = "/solutions/:id/feedbacks",
  feedback = "/feedback",
  resources = "/resources",
  profile = "/profile/:id",
  certificate = "/certificate/:id",
  paths = "/paths",
  notifications = "/notifications",
  pathDetails = "/paths/:id",
  blogs = "https://blogs.devchallenges.io/",
  badges = "/topUsers/badges",
  termOfUse = "/termOfUse",
  topUsers = "/topUsers",
  privacyPolicy = "/privacyPolicy",
  settings = "/settings",
}
